import { useCallback, useEffect, useLayoutEffect, useRef } from "react";
import { useBoolean } from "./useBoolean";

export const useTimeout = (callback, delay, clearOnUnmount= true, manageActivated = false) => {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef(null);
  const [isActivated, startTimeout, stopTimeout] = useBoolean(false);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  },[callback]);

  const clear = useCallback(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
    if (manageActivated) {
      stopTimeout();
    }
  },[manageActivated, stopTimeout]);

  const start = useCallback(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    // -1の場合は実行しない
    if (delay === -1) {
      return;
    }
    timeoutRef.current = setTimeout(() => {
      callbackRef.current && callbackRef.current();
      clear();
    }, delay);
    if (manageActivated) {
      startTimeout();
    }
  },[clear, delay, manageActivated, startTimeout]);

  useEffect(() => {
    return () => {
      if (clearOnUnmount) {
        clear();
      }
    };
  },[clear, clearOnUnmount]);

  return [
    start,
    clear,
    !manageActivated ? undefined : isActivated
  ]
};